import _ from 'lodash'
import config from '../actions/productsActions'

// FILTERS
export const getOrderedFilters = (filters) => {
  let newFilters = { ...filters }

  if (
    typeof window.containerTypeFilters != 'undefined' &&
    window.containerTypeFilters == 0 &&
    typeof newFilters.ContainerType != 'undefined'
  ) {
    delete newFilters.ContainerType
  }

  if (
    typeof window.countryFilters != 'undefined' &&
    window.countryFilters == 0 &&
    typeof newFilters.Country != 'undefined'
  ) {
    delete newFilters.Country
  }

  if (
    typeof window.regionFilters != 'undefined' &&
    window.regionFilters == 0 &&
    typeof newFilters.Region != 'undefined'
  ) {
    delete newFilters.Region
  }

  if (typeof window.brandFilters != 'undefined' && window.brandFilters == 0 && typeof newFilters.Brand != 'undefined') {
    delete newFilters.Brand
  }

  return Object.entries(filters).reduce((newList, [key, values], index) => {
    let sortColumn = ''
    let sortDirection = ''

    let sort = filters[key]?.[0]?.sortBy || false
    switch (sort) {
      case 'Alphabetical Z-A':
        sortColumn = 'title'
        sortDirection = 'desc'
        break
      case 'Alphabetical A-Z':
        sortColumn = 'title'
        sortDirection = 'asc'
        break
      case 'Count Low to High':
        sortColumn = 'count'
        sortDirection = 'asc'
        break
      case 'Count High to Low':
        sortColumn = 'count'
        sortDirection = 'desc'
        break
      default:
        break
    }
    newList[key] = _.orderBy(Object.values(values), [sortColumn], [sortDirection])
    return newList
  }, {})
}

// PRODUCTS
export const getStartingIndex = (perPage, activePage) => {
  const index = (activePage - 1) * perPage
  return index > 0 ? index : 0
}
// export const getTotalPerPage = (perPage) => {
//     return storageAvailable('localStorage') ? Number(LS.get('perPage')) || perPage : perPage;
// };
export const getProductsFullInfo = (list, store) => {
  const { products } = store
  const productsList = products.present.list
  let newList = {}

  Object.entries(list).filter(([key, product]) => {
    /**
     * Skip undefined
     */
    if (!product) {
      return false
    }

    /**
     * Image is relative URL. Combine baseURL to get full URL
     */
    let { image } = product
    if (window?.isLocalhost) {
      image = window?.baseURL + image
    }

    newList[key] = {
      ...list[key],
      ...productsList[key],
      image,
    }

    return true
  })

  return newList
}
export const getProductsArray = (products) => {
  return products ? Object.values(products) : []
}
export const getProductsByCategory = (productsList, category) => {
  let products = {}
  Object.entries(productsList).map(([key, product]) => {
    if (product.categories && product.categories[category]) {
      products[key] = product
    }
  })
  return products
}
export const getProductsByFilters = (productsList, filters) => {
  let products = {}
  const checkedFilters = getCheckedFilters(filters)
  const { brands, countries, regions, types, styles } = checkedFilters

  Object.entries(productsList).map(([key, product]) => {
    const { brand, region, country, type, style } = product

    if (brands.length > 0 && !brands.includes(brand)) return
    if (regions.length > 0 && !regions.includes(region)) return
    if (countries.length > 0 && !countries.includes(country)) return
    if (types.length > 0 && !types.includes(type)) return
    if (styles.length > 0 && !styles.includes(style)) return

    products[key] = product
  })

  return products
}
// HELPERS
export const isNewArrivalRequest = () => {
  if (typeof window.isNewArrival != 'undefined' && window.isNewArrival) {
    return true
  }

  return false
}
export const isSearchRequest = () => {
  if (typeof window.isSearch != 'undefined' && window.isSearch) {
    return true
  }

  return false
}

export const buildRequestProductListParams = (state) => {
  const params = []

  Object.keys(state).map((key) => {
    // console.log(state[key])
    if (
      JSON.stringify(state[key]) !== 'null' &&
      JSON.stringify(state[key]) !== '[]' &&
      typeof state[key] !== 'undefined'
    ) {
      if (typeof state[key] === 'string') {
        params.push(`${key}: "${state[key]}"`)
      } else if (Array.isArray(state[key])) {
        params.push(`${key}: ${JSON.stringify(state[key])}`)
      } else {
        params.push(`${key}: ${state[key]}`)
      }
    }
  })

  return params.join(', ')
}

export const getProductURL = (URLSegment = '') => {
  return `/product/${URLSegment}`
}
